import { Controller } from "@hotwired/stimulus"

// Displays a live-updating duration (e.g. "1h 15m") from a start time.
export default class extends Controller {
  static values = {
    startedAt: String
  }

  static targets = ["output"]

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    if (!this.hasOutputTarget || !this.startedAtValue) return
    const start = new Date(this.startedAtValue)
    const now = new Date()
    const sec = Math.floor((now - start) / 1000)
    const m = Math.floor(sec / 60)
    const h = Math.floor(m / 60)
    const mins = m % 60
    const text = h > 0 ? `${h}h ${mins}m` : `${m} min`
    this.outputTarget.textContent = text
  }
}
